import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMessageCircle, FiMapPin, FiPhone, FiInstagram, FiSearch } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-100 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-4 gap-12 mb-16">
          <div className="col-span-1 lg:col-span-1">
            <Link to="/" className="flex items-center mb-6">
              <img src="https://i.imgur.com/LJ9Fcbk.png" alt="UniPET Logo" className="h-10 w-auto object-contain" />
            </Link>
            <p className="text-gray-500 text-sm leading-relaxed max-w-xs font-medium">
              Referência em estética animal no Centro de Juiz de Fora. Cuidado profissional sob supervisão técnica da Dra. Luene Gomes.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-bold text-blue-900 uppercase tracking-widest mb-6">Onde Estamos</h4>
            <ul className="space-y-4 text-gray-500 text-sm">
              <li className="flex items-start">
                <SafeIcon icon={FiMapPin} className="mt-1 mr-3 text-blue-900 flex-shrink-0" />
                <span>Rua Delfim Moreira, 125, Centro<br/>Juiz de Fora - MG</span>
              </li>
              <li className="flex items-center">
                <SafeIcon icon={FiPhone} className="mr-3 text-blue-900 flex-shrink-0" />
                <span>(32) 99985-7587</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-bold text-blue-900 uppercase tracking-widest mb-6">Links Úteis</h4>
            <ul className="space-y-3 text-sm text-gray-500 font-bold">
              <li><Link to="/sobre" className="hover:text-blue-900 transition-colors">Sobre Nós</Link></li>
              <li><Link to="/servicos" className="hover:text-blue-900 transition-colors">Serviços Estéticos</Link></li>
              <li>
                <a href="https://quiz.unipet.online/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 flex items-center gap-2">
                  <SafeIcon icon={FiSearch} /> Quiz: Serviço Ideal
                </a>
              </li>
              <li><Link to="/cupons" className="text-orange-600 hover:text-orange-700">Cupom de Desconto</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-bold text-blue-900 uppercase tracking-widest mb-6">Atendimento</h4>
            <div className="space-y-3">
              <a href="http://wa.me/5532999857587" target="_blank" rel="noopener noreferrer" className="flex items-center p-3 border border-gray-100 rounded-xl hover:bg-green-50 hover:border-green-100 transition-all group">
                <div className="w-8 h-8 bg-green-500 rounded-lg flex items-center justify-center text-white mr-3">
                  <SafeIcon icon={FiMessageCircle} className="w-4 h-4" />
                </div>
                <span className="text-sm font-bold text-gray-700">WhatsApp</span>
              </a>
              <div className="flex gap-2">
                <a href="http://instagram.com/unipet.jf" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-50 rounded-lg flex items-center justify-center text-gray-400 hover:text-pink-600 hover:bg-pink-50 transition-all">
                  <SafeIcon icon={FiInstagram} className="w-5 h-5" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-100 pt-8 flex flex-col md:flex-row justify-between items-center text-gray-400 text-xs gap-4">
          <p>© {new Date().getFullYear()} UniPET. Todos os direitos reservados.</p>
          <p className="font-bold text-blue-900/60">Dra. Luene Gomes - CRMV-MG 29719</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;